import { handleClubImgError } from "../../handleImgError";
import { getClubPhoto } from "../../utils/getMedia";

export interface PromoterGroupClubRow {
  clubName: string;
  offerType?: string;
  status?: string;
  statusColor?: string;
  onClick?: () => void;
}

interface PromoterGroupClubRowsProps {
  city: string;
  clubs: PromoterGroupClubRow[];
}

const PromoterGroupClubRows: React.FC<PromoterGroupClubRowsProps> = ({
  city,
  clubs,
}) => (
  <div className="promoter-group-detail__offer-list">
    {clubs.map((club) => (
      <div
        className={`promoter-group-detail__offer-row${club.onClick ? " promoter-group-detail__offer-row--clickable" : ""}`}
        key={club.clubName}
        role={club.onClick ? "button" : undefined}
        tabIndex={club.onClick ? 0 : undefined}
        onClick={club.onClick}
        onKeyDown={(event) => {
          if (!club.onClick) {
            return;
          }

          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            club.onClick();
          }
        }}
      >
        <img
          src={getClubPhoto({ clubName: club.clubName, cityName: city })}
          alt=""
          className="promoter-group-detail__club-image"
          onError={handleClubImgError}
        />
        <span className="promoter-group-detail__club-info">
          <span className="yellowTxt promoter-group-detail__club-name">
            {club.clubName}
          </span>
          {club.offerType ? (
            <span className="promoter-group-detail__offer-type">
              {club.offerType}
            </span>
          ) : null}
        </span>
        {club.status ? (
          <span
            className="promoter-group-detail__offer-status"
            style={{ color: club.statusColor }}
          >
            {club.status}
          </span>
        ) : null}
      </div>
    ))}
  </div>
);

export default PromoterGroupClubRows;
